export default class AssignorModel {
  constructor() {
    this.assignorId = '';
    this.name = '';
    this.memberId = '';
    this.cellphone = '';
    this.companyPhone = '';
    this.agentId = '';
    this.birthday = '';
    this.createdDate = new Date();
  }
}



// WEBPACK FOOTER //
// ./src/models/AssignorModel.js